<template>
  <section class="dao">
    <div class="bg-black w-full blex content-start">

      <div class="blex w-full pt-0 pb-150-vw z-50">
        <div class="blex w-full">
          <div class="text-white font-bold text-2xl lg:text-6xl blex bottom-gradient pb-12">
            DAO
          </div>
        </div>
        <div class="text-white font-medium text-2xs lg:text-base leading-xs py-30 text-center blex z-5">
          {{ $t('dao.1') }}<br class="block lg:hidden">
          {{ $t('dao.2') }}<br><br class="block lg:hidden">
          {{ $t('dao.3') }}<br class="block lg:hidden">
          {{ $t('dao.4') }}
        </div>
      </div>

      <!--  circle wrapper      -->
      <div class="w-full blex lg:flex-no-wrap lg:w-2/5 lg:px-0 px-16">
        <!--  governance circle      -->
        <div class="w-full">
          <div class="circle">
            <div class="dao-left on" ref="dao-left">
              <div class="z-1 dao red1">
                <img src="@/assets/images/pages/main/dao/daoRed1.svg" alt="" class="w-9/10">
              </div>
              <div class="z-2 dao red2">
                <img src="@/assets/images/pages/main/dao/daoRed2.svg" alt="" class="w-9/10">
              </div>
              <div class="z-3 dao red3">
                <img src="@/assets/images/pages/main/dao/daoRed3.svg" alt="" class="w-9/10">
              </div>
              <div class="z-4 dao red4">
                <img src="@/assets/images/pages/main/dao/daoRed4.svg" alt="" class="w-9/10">
              </div>
            </div>
            <img src="@/assets/images/pages/main/dao/daoCircle.svg" class="w-full">
            <div class="governance">
              <div class="blex">
                <div class="text-white font-semiBold text-xs lg:text-5xl w-full blex">
                  {{ $t('dao.5') }}
                </div>
                <div class="line"></div>
              </div>
              <div class="text-white font-medium leading-xs lg:leading-sm text-2xs lg:text-base text-center">
                {{ $t('dao.6') }}
              </div>
            </div>
          </div>
        </div>

        <!--  guild circle      -->
        <div class="w-full blex-right lg:block">
          <div class="circle">
            <div class="dao-right on" ref="dao-right">
              <div class="z-1 dao green1">
                <img src="@/assets/images/pages/main/dao/dao2.svg" alt="" class="w-9/10">
              </div>
              <div class="z-2 dao green2">
                <img src="@/assets/images/pages/main/dao/dao3.svg" alt="" class="w-9/10">
              </div>
              <div class="z-3 dao green3">
                <img src="@/assets/images/pages/main/dao/dao4.svg" alt="" class="w-9/10">
              </div>
              <div class="z-4 dao green4">
                <img src="@/assets/images/pages/main/dao/dao5.svg" alt="" class="w-9/10">
              </div>
            </div>
            <img src="@/assets/images/pages/main/dao/daoCircle.svg" class="w-full">
            <div class="guild">
              <div class="blex">
                <div class="text-white font-semiBold text-xs lg:text-5xl w-full blex">
                  {{ $t('dao.7') }}
                </div>
                <div class="line"></div>
              </div>
              <div class="text-white font-medium leading-xs lg:leading-sm text-2xs lg:text-base text-center">
                {{ $t('dao.8') }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
let timeline = null
export default {
  name: 'Dao',
  data: () => ({
    imageCount: 0,
    loadedImageCount: 0
  }),
  methods: {
    animations () {
      timeline = this.$gsap.timeline({
        // invalidateOnRefresh: true,
        // scroller: '#index',
        // trigger: 'section.dao',
        // start: 'top 150px',
        // scrub: true,
        // preventOverlaps: true,
        // fastScrollEnd: true,
        // toggleActions: 'restart none reverse none'
        scrollTrigger: {
          invalidateOnRefresh: true,
          scroller: '#index',
          trigger: 'section.dao',
          start: 'top',
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none',
          onEnter: () => {
            this.$refs['dao-left'].classList.add('on')
            this.$refs['dao-right'].classList.add('on')
          },
          onLeaveBack: () => {
            this.$refs['dao-left'].classList.remove('on')
            this.$refs['dao-right'].classList.remove('on')
          }
        }
      })

      // timeline.to('.dao-left', {
      //   duration: 1,
      //   className: 'on dao-left'
      // }).to('.dao-right', {
      //   duration: 1,
      //   className: 'on dao-right'
      // }, '-=1')

    }
  },
  watch: {
    loadedImageCount (val) {
      // if (this.imageCount === val && this.$scrollTrigger) {
      //   this.$scrollTrigger.refresh()
      // }
    }
  },
  mounted () {
    const images = this.$el.querySelectorAll('img')
    this.imageCount = images.length
    images.forEach(img => {
      if (img.complete) {
        this.loadedImageCount++
      } else {
        img.addEventListener('load', () => this.loadedImageCount++)
      }
    })
  },
  beforeDestroy () {
    if (timeline) {
      timeline.kill()
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {

  //height: calc(var(--vh, 1vh) * 10);

  //@media (max-width: 1280px) {
  height: calc(var(--vh, 1vh) * 130);
  //}

  @media (max-width: 1024px) {
    height: calc(var(--vh, 1vh) * 120);
  }

  @media (max-width: 768px) {
    height: calc(var(--vh, 1vh) * 110);
  }

  @media (max-width: 640px) {
    height: calc(var(--vh, 1vh) * 100);
  }

  .circle {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 480px;
    height: 480px;
    padding: 0 48px;
    z-index: 10;

    @media screen and (max-width: 1024px) {
      width: 270px;
      height: 270px;
      padding: 0;
    }


    .line {
      width: 84px;
      height: 1px;
      background-color: #fff;
      margin-top: 16px;
      margin-bottom: 40px;

      @media screen and (max-width: 1024px) {
        width: 22px;
        margin-top: 4px;
        margin-bottom: 20px;


      }
    }

    .governance,
    .guild {
      position: absolute;
      width: 70%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
      align-items: center;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 5;
    }

    .dao-left {
      opacity: 0;
      position: absolute;
      top: 60%;
      //left: 32%;
      left: 20%;
      //width: 27.083vw;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      align-items: center;
      align-content: center;
      justify-content: flex-start;
      justify-items: flex-start;

      @media screen and (max-width: 1024px) {
        width: 50.083vw;
        top: 60%;
        left: 15%;
      }


      &.on {
        opacity: 1;

        .red1 {
          transform: translate(100%, -100%);
          //animation: toBottom 1s .5s cubic-bezier(1, -0.01, 0, 1.02) forwards;
          animation: toBottom .8s linear forwards;
          z-index: 2;
        }

        .red2 {
          transform: translate(100%, -100%);
          animation: toBottom .6s linear forwards;
          //animation: toBottom 1s .6s cubic-bezier(1, -0.01, 0, 1.02) forwards;
          z-index: 1;
        }

        .red3 {
          transform: translate(100%, -100%);
          animation: toBottom 1s linear forwards;
          //animation: toBottom 1s .7s cubic-bezier(1, -0.01, 0, 1.02) forwards;
          z-index: 4;
        }

        .red4 {
          transform: translate(100%, -100%);
          animation: toBottom 1.2s linear forwards;
          //animation: toBottom 1s .8s cubic-bezier(1, -0.01, 0, 1.02) forwards;
          z-index: 3;
        }

      }
    }

    .dao-right {
      opacity: 0;
      position: absolute;
      top: 60%;
      //width: 27.083vw;
      width: 100%;
      right: 20%;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      align-items: center;
      align-content: center;
      justify-content: flex-end;
      justify-items: flex-end;
      z-index: -1;
      @media screen and (max-width: 1024px) {
        width: 50.083vw;
        top: 70%;
        right: 15%;

      }


      &.on {
        opacity: 1;

        .green1 {
          transform: translate(-100%, 100%);
          animation: toTop .8s linear forwards;
          //animation: toTop 1s .1s linear forwards;
        }

        .green2 {
          transform: translate(-100%, 100%);
          animation: toTop .6s linear forwards;
        }

        .green3 {
          transform: translate(-100%, 100%);
          animation: toTop 1.2s linear forwards;
        }

        .green4 {
          transform: translate(-100%, 100%);
          animation: toTop 1s linear forwards;
        }

      }


    }

  }

  .dao {
    position: absolute;
    //mix-blend-mode: lighten;
    mix-blend-mode: exclusion;
  }

  @keyframes appear {
    0% {
      opacity: 0;
    }
    50% {
      opacity: .5;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes toBottom {
    0% {
      opacity: 0;
      transform: translate(100%, -100%);
    }
    100% {
      opacity: 1;
      transform: translate(0);
    }
  }

  @keyframes toTop {
    0% {
      opacity: 0;
      transform: translate(-100%, 100%);
    }
    100% {
      opacity: 1;
      transform: translate(0);
    }
  }


}


</style>
